import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

type EmployeeMutationOptions = UseMutationOptions<string, unknown, string>;

export const useArchiveEmployee = () => {
  const mutationFn = async (employeeId: string) =>
    await sharedWorkforceService.archiveEmployee(employeeId);

  const queryClient = useQueryClient();
  const mutationOptions: EmployeeMutationOptions = {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.workforce());
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
